var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRecurring = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M4 .5a.5.5 0 0 1 .5.5v2.5h-1V1A.5.5 0 0 1 4 .5m8 0a.5.5 0 0 1 .5.5v2.5h-1V1a.5.5 0 0 1 .5-.5m3 2h-1.5v-1H15a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h7.293L6.146 6.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L8.293 9.5H1v6h14zm-9.5-1h5v1h-5zm-3 0H1a1 1 0 0 0-1 1v3h1v-3h1.5z",
  clipRule: "evenodd"
})));
export default SvgRecurring;